import React, { type FC } from 'react'

import { Translation } from '../../../domain'

import { AbsoluteRouteOnlyPath, useHasCapabilities } from '../routing'
import { RouteTabs } from '../Tabs'

const tabs = {
    [AbsoluteRouteOnlyPath.STORYBOOK_FOUNDATIONS]: {
        documentationTitle: Translation.STORYBOOK_FOUNDATIONS_DOCUMENTATION_TITLE,
        documentationBody: Translation.STORYBOOK_FOUNDATIONS_DOCUMENTATION_BODY,
    },
    [AbsoluteRouteOnlyPath.STORYBOOK_INPUTS]: {
        documentationTitle: Translation.STORYBOOK_INPUTS_DOCUMENTATION_TITLE,
        documentationBody: Translation.STORYBOOK_INPUTS_DOCUMENTATION_BODY,
    },
    [AbsoluteRouteOnlyPath.STORYBOOK_BUTTONS]: {
        documentationTitle: Translation.STORYBOOK_BUTTONS_DOCUMENTATION_TITLE,
        documentationBody: Translation.STORYBOOK_BUTTONS_DOCUMENTATION_BODY,
    },
    [AbsoluteRouteOnlyPath.STORYBOOK_CHIPS_AND_STATUSES]: {
        documentationTitle: Translation.STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_TITLE,
        documentationBody: Translation.STORYBOOK_CHIPS_AND_STATUSES_DOCUMENTATION_BODY,
    },
    [AbsoluteRouteOnlyPath.STORYBOOK_TABLES]: {
        documentationTitle: Translation.STORYBOOK_TABLES_DOCUMENTATION_TITLE,
        documentationBody: Translation.STORYBOOK_TABLES_DOCUMENTATION_BODY,
    },
    [AbsoluteRouteOnlyPath.STORYBOOK_NOTIFICATIONS]: {
        documentationTitle: Translation.STORYBOOK_NOTIFICATIONS_DOCUMENTATION_TITLE,
        documentationBody: Translation.STORYBOOK_NOTIFICATIONS_DOCUMENTATION_BODY,
    },
}

/**
 * `SwitchingRoute` renders its prefix outside the routes' own access check, so the tabs gate themselves
 */
export const StorybookTabs: FC = () => {
    const hasCapabilities = useHasCapabilities()
    return hasCapabilities(AbsoluteRouteOnlyPath.STORYBOOK) ? <RouteTabs title={Translation.STORYBOOK} tabs={tabs} /> : null
}
